(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('ScheduledTaskDeleteController',ScheduledTaskDeleteController);

    ScheduledTaskDeleteController.$inject = ['$uibModalInstance', 'entity', 'ScheduledTask'];

    function ScheduledTaskDeleteController($uibModalInstance, entity, ScheduledTask) {
        var vm = this;

        vm.scheduledTask = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ScheduledTask.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
